exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".drawer-container[data-v-97111af6] {\n  position: fixed;\n}\n", ""]);

